<template>
  <wdw-dynbox
    :title="domainStore.translate('discuss.statement.title')"
    :config="{ showControls: true }"
    :minimize="false"
    v-if="statementData.length > 0"
  >
    <div class="statement-container" v-for="statement in statementData" :key="statement.id">
      <p class="authors-name">
        {{ domainStore.translate('discuss.statement.authored_by', { name: statement.author_name }) }}
      </p>

      <p class="authors-statement">"{{ statement.text }}"</p>
    </div>
  </wdw-dynbox>
</template>

<script>
import WdwDynbox from '@/components/general/WdwDynbox.vue';
import { ref, toRef } from '@vue/reactivity';
import { onBeforeMount } from '@vue/runtime-core';
import { domainStore } from '@/store/domain-store';
import thoughtRepository from '@/api/thoughtRepository';
export default {
  name: 'Statements',

  props: {
    thoughtid: {
      type: Number,
      required: true,
    },
  },

  setup(props, context) {
    const thoughtId = toRef(props, 'thoughtid');
    const statementData = ref([]);
    onBeforeMount(() => {
      thoughtRepository
        .getStatements(thoughtId.value)
        .then(res => {
          statementData.value = res;
        })
        .catch(error => {
          if (error.response && error.response.status !== 404) {
            console.log(error);
          }
        });
    });

    return {
      domainStore,
      statementData,
    };
  },

  components: {
    WdwDynbox,
  },
};
</script>

<style scoped>
.statement-container {
  border-bottom: 1px solid grey;
  margin-bottom: 15px;
  margin-top: 15px;
}
.authors-name {
  font-weight: lighter;
  font-size: 1.2rem;
}
.authors-statement {
  margin-left: 10px;
  padding: 10px 25px;
  border-left: 5px solid rgba(119, 136, 153, 0.171);
  border-top-left-radius: 3px;
  border-bottom-left-radius: 3px;
}
</style>
